import { createContext } from 'react';
import { ConditionsData } from '@/hooks/useConditionsData';
import { AllergiesData } from '@/hooks/useAllergiesData';
import { MedicationsData } from '@/hooks/useMedicationsData';
import { ProceduresData } from '@/hooks/useProcedureData';
import { OperationOutcome, Patient } from '@medplum/fhirtypes';

export interface PatientResourcesLoadingState {
  readonly conditions: boolean;
  readonly allergies: boolean;
  readonly medications: boolean;
  readonly procedures: boolean;
}

export interface PatientResourcesContextType {
  readonly patient: Patient | undefined;

  readonly outcome: OperationOutcome | undefined;

  readonly handlePatientUpdate: (patient: Patient) => void;
  //Conditions organized by category
  readonly conditions: ConditionsData;

  //Patient allergies
  readonly allergies: AllergiesData;

  //Patient medications
  readonly medications: MedicationsData;

  //Patient procedures and therapeutic interventions
  readonly procedures: ProceduresData;

  //Loading states per resource type
  readonly loading: PatientResourcesLoadingState;

  // Manually refetch functions
  readonly refetchConditions: () => Promise<void>;
  readonly refetchAllergies: () => Promise<void>;
  readonly refetchMedications: () => Promise<void>;
  readonly refetchProcedures: () => Promise<void>;
}

// Context for patient resources with real-time updates.
// Must be used within a PatientResourcesProvider.

export const PatientResourcesContext = createContext<
  PatientResourcesContextType | undefined
>(undefined);
